export const PATHS = {
  // Public pages / 公開ページ
  ROOT: '/', // トップページ
  HOME: '/home', // ホーム
  PRIVACY: '/privacy', // プライバシーポリシー
  TERMS: '/terms', // 利用規約
  PROFILE: '/profile', // プロフィール
  ORDERS: '/orders', // 注文履歴
  CHECKOUT: '/checkout', // チェックアウト

  // Shipping address pages / お届け先管理ページ
  SHIPPING: {
    LIST: '/shipping', // お届け先一覧
    NEW: '/shipping/new', // 新しいお届け先登録
    EDIT: '/shipping/edit', // お届け先編集
    SUCCESS: '/shipping/success', // 登録完了
  },

  // Auth pages / 認証関連ページ
  AUTH: {
    LOGIN: '/auth/login', // ログイン
    RESET_PASSWORD: '/auth/reset-password', // パスワードリセット
    SIGNUP: {
      // 新規登録
      STEP1: '/auth/signup/step1', // ステップ1（メール入力など）
      STEP2: '/auth/signup/step2', // ステップ2
      STEP3: '/auth/signup/step3', // ステップ3
      STEP4: '/auth/signup/step4', // ステップ4
      COMPLETE: '/auth/signup/complete', // 完了
    },
  },

  // Service pages (legacy - for existing /auth redirect) / サービスページ（旧リダイレクト用）
  SERVICE: {
    AUTH: '/auth', // 認証
  },

  // External URLs / 外部URL
  EXTERNAL: {
    COMPANY: 'https://nomiss.co.jp/', // 会社概要
    TOKUSHOHO: 'https://nomiss.co.jp/law/', // 特定商取引法
  },
} as const;

// Type helper for path values / パス値の型ヘルパー
export type PathType = typeof PATHS;
export type AuthPath = PathType['AUTH'];
export type SignupPath = AuthPath['SIGNUP'];
export type ExternalPath = PathType['EXTERNAL'];
